// @flow

import React from 'react';
import PropTypes from 'prop-types';

import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { Container } from '@material-ui/core/';
import { Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';

import AppTheme from '../themes';
import HeaderBar from '../components/headerbar';
import Footer from '../components/footer';
import IdleTimer from '../components/idleTimer';

//import Home from '../pages/home';
import ApiProducts from '../pages/apiproducts';
import ApiDocs from '../pages/apiproducts/docs';
import TryApi from '../pages/apiproducts/tryapi';
import Docs from '../pages/docs';
import API from '../pages/api';
import Download from '../pages/download';
import Support from '../pages/support';
import SignIn from '../pages/signin';
import NotificationLearn from '../components/home/notification';
import NotificationView from '../components/home/notification/viewdocs';
import UserProfile from '../pages/userprofile';
import SSO from'../pages/SSO';
import './style.css';

export const DEVPORTAL_LOGIN_INFO = 'devPortalLoginInfo';
export const API_AUTH_TOKEN = 'apiAuthToken';
export const UserContext = React.createContext({});
export const AuthTokenContext = React.createContext({});

function App(props) {
    const [currentUser, setCurrentUser] = React.useState(null);
    const [authToken, setAuthToken] = React.useState('');
    const { BaseUrl } = props;

    React.useEffect(() => {
        const loggedInUserData = sessionStorage.getItem(DEVPORTAL_LOGIN_INFO);
        const token = sessionStorage.getItem(API_AUTH_TOKEN);
        if (loggedInUserData) {
            setCurrentUser(JSON.parse(loggedInUserData));
        } else {
            setCurrentUser(null);
        }
        if (token) {
            setAuthToken(JSON.parse(token));
        } else {
            setAuthToken('');
        }
    }, [props]);

    const handleLoginUser = (data) => {
        sessionStorage.clear();
        setCurrentUser(data);
        sessionStorage.setItem(DEVPORTAL_LOGIN_INFO, JSON.stringify(data));
        return Promise.resolve(true);
    };

    const handleLogoutUser = () => {
        sessionStorage.clear();
        setCurrentUser(null);
        return Promise.resolve(true);
    };

    const handleSaveAuthToken = (token) => {
        setAuthToken(token);
        sessionStorage.setItem(API_AUTH_TOKEN, JSON.stringify(token));
        return Promise.resolve(true);
    };

    return (
        <AuthTokenContext.Provider value={{ authToken, handleSaveAuthToken }}>
        <UserContext.Provider value={{ currentUser, handleLogoutUser, handleLoginUser }}>
        <MuiThemeProvider theme={AppTheme}>
            <HeaderBar />
            <Container maxWidth={false} className="app-container">
                <BrowserRouter basename={BaseUrl}>
                    {currentUser ? <IdleTimer /> : null}
                    <Route exact path="/" component={ApiProducts} />
                    <Route path="/apiproducts" component={ApiProducts} />
                    <Route
                        path="/docs"
                        component={() => <Docs location="Introduction" />}
                    />
                    <Route
                        path="/docs-state"
                        component={() => (
                            <Docs location="Introduction" scroll="yes" />
                        )}
                    />
                    <Route path="/api" component={API} />
                    <Route path="/download" component={Download} />
                    <Route
                        path="/support"
                        component={() => <Support location="0" />}
                    />
                    <Route path="/signin" component={SignIn} />
                    <Route path="/api-docs" component={ApiDocs} />

                    <Route
                        path="/docs-api/:ApiName/:tabname"
                        component={ApiDocs}
                    />

                    <Route
                        path="/try-api/:PageName/:tabname"
                        component={TryApi}
                    />
                    <Route
                        path="/docs-page/:DocsPageName"
                        component={() => <Docs location="Introduction" />}
                    />

                    <Route
                        path="/notification-view"
                        component={NotificationView}
                    />
                    <Route
                        path="/notification-Learn"
                        component={NotificationLearn}
                    />
                    <Route
                        path="/contact-support"
                        component={() => <Support location="1" />}
                    />
                    <Route
                        path="/docs-ver-uploadbinder"
                        component={() => (
                            <Docs
                                location="version4-uploadbinderdocuments"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-ver-submitbinder"
                        component={() => (
                            <Docs
                                location="version4-bindersubmissioncomplete"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-uploadbinder"
                        component={() => (
                            <Docs
                                location="currentver-uploadbinderdocuments"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-submitbinder"
                        component={() => (
                            <Docs
                                location="currentver-bindersubmissioncomplete"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-gettoken"
                        component={() => (
                            <Docs location="currentver-gettoken" scroll="no" />
                        )}
                    />
                    <Route
                        path="/docs-createbinder"
                        component={() => (
                            <Docs
                                location="currentver-createbinder"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-getbinderdetails"
                        component={() => (
                            <Docs
                                location="currentver-getbinderdetails"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-getdocuments"
                        component={() => (
                            <Docs
                                location="currentver-getdocuments"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-downloaddocuments"
                        component={() => (
                            <Docs
                                location="currentver-downloaddocument"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-bindertemplate"
                        component={() => (
                            <Docs
                                location="currentver-bindertemplates"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-servicetype"
                        component={() => (
                            <Docs
                                location="currentver-servicetypes"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-officelocation"
                        component={() => (
                            <Docs
                                location="currentver-officelocations"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/docs-pushengagementstatus"
                        component={() => (
                            <Docs
                                location="currentver-pushengagementstatus"
                                scroll="no"
                            />
                        )}
                    />
                    <Route
                        path="/try-con-createbinder"
                        component={() => <TryApi location="createbinder.json" />}
                    />
                    <Route
                        path="/try-api-gettoken"
                        component={() => <TryApi location="gettoken.json" />}
                    />
                    <Route
                        path="/try-con-uploadbinder"
                        component={() => <TryApi location="uploadbinder.json" />}
                    />
                    <Route
                        path="/try-con-submitbinder"
                        component={() => <TryApi location="submitbinder.json" />}
                    />
                    <Route
                        path="/userprofile"
                        component={() => <UserProfile />}
                    />
                    <Route
                        path="/sso"
                        component={() => <SSO />}
                    />
                </BrowserRouter>
            </Container>
            <Footer />
        </MuiThemeProvider>
        </UserContext.Provider>
        </AuthTokenContext.Provider>
    );
}

App.propTypes = {
    BaseUrl: PropTypes.string,
};

export default App;
